import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { useToast } from "hooks/useToast";
import { useDeletePayrollMutation } from "store/apis/payroll";
import { Payroll } from "types/Models/payroll";
import { BackendError } from "types/utils/error";
import { ModalProps } from "types/utils/modal";

type DeleteModalProps = {
  payroll: Payroll;
  entityId: string;
} & ModalProps;

export default function DeleteModal({
  payroll,
  entityId,
  ...modalProps
}: DeleteModalProps) {
  const { alertToast, successToast } = useToast();
  const [deletePayroll, { isLoading }] = useDeletePayrollMutation();
  const onDelete = async () => {
    try {
      await deletePayroll({ entityId, payrollId: payroll.uuid }).unwrap();
      successToast({
        message: "Payroll report deleted",
      });
      modalProps.close();
    } catch (error) {
      alertToast(
        {
          message: (error as BackendError).data?.error?.message,
        },
        error as Error
      );
    }
  };

  return (
    <Modal.Root open={modalProps.isOpen} onOpenChange={modalProps.close}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Delete payroll report</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body className="t-text-body-sm t-text-text-30">
          This will permanently delete the payroll report and its linked journal
          entry. This action cannot be undone.
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button disabled={isLoading}>Cancel</Button>
          </Modal.RawClose>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            customType="danger"
            onClick={onDelete}
          >
            Delete
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
}
